module.exports = __webpack_public_path__ + "media/images/country_flags/ro-80648912266fff2245c400d724cc5da1.png";